


































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { RelatedDocumentModel, BaseColumnsModel, RelatedDocumentViewModel, BaseDocumentSearchModel, DocumentTypeModel, DocumentDataModel, TabStateModel, DocumentPageModel } from '@/types';
import { BTableHelpers, TabsHelper } from '@/mixins';
import store from '@/store';

export default Vue.extend({
  name: 'MStoreRelatedDocumentsTab',
  mixins: [BTableHelpers, TabsHelper],
  data() {
    return {
      sortBy: 'cb_docdate',
      sortDesc: true,
      collapseLoading: true,
      documentLinkId: 0
    };
  },
  props: {
    isRelatedDocumentOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions('documentViewStore', ['loadPage', 'setDocumentSearchModel', 'setRelatedDocumentBeingViewed', 'retrieveDocumentActions']),
    ...mapActions('relatedDocumentsStore', ['getRelatedDocuments', 'unloadRelatedDocuments', 'updateDocumentDataPageCount']),
    getPanelIcon(visible: boolean): string {
      return visible ? 'chevron-down' : 'chevron-right';
    },
    getOriginalDocument(this: any) {
      this.setRelatedDocumentAndRetrieveActions({});
    },
    onRelatedDocumentViewButtonClicked(this: any, item: any, linkId: number) {
      const relatedDocument = {
        linkId,
        documentSearchModel: {
          cabinetId: item.cabinetid,
          documentId: item.cb_docid,
          documentTypeId: item.cb_dtid
        } as BaseDocumentSearchModel,
        documentType: this.getDocumentType(linkId, item.cabinetid, item.cb_docid) as DocumentTypeModel
      } as RelatedDocumentViewModel;
      this.setRelatedDocumentAndRetrieveActions(relatedDocument);
    },
    setRelatedDocumentAndRetrieveActions(relatedDocument: RelatedDocumentViewModel) {
      this.setRelatedDocumentBeingViewed(relatedDocument);
      this.retrieveDocumentActions();
    },
    onRelatedDocumentRowClicked(item: any, index: any, event: any) {
      if (this.relatedDocumentIsBeingViewed(item) && !this.isDocumentLoadingOrBeingConverted) {
        this.getOriginalDocument();
      } else {
        this.onRelatedDocumentViewButtonClicked(item, item.linkid);
      }
    },
    getCountText(relatedDocument: RelatedDocumentModel) {
      return relatedDocument.documentCount === 1 ? `${relatedDocument.documentCount} Document` : `${relatedDocument.documentCount} Documents`;
    },
    relatedDocumentIsBeingViewed(this: any, item: any): boolean {
      return (
        this.relatedDocumentBeingViewed.documentSearchModel &&
        this.relatedDocumentBeingViewed.documentSearchModel.documentId === item.cb_docid &&
        this.relatedDocumentBeingViewed.documentSearchModel.cabinetId.toString() === item.cabinetid.toString()
      );
    },
    getDocumentType(this: any, linkId: number, cabinetId: string, documentId: number): DocumentTypeModel | undefined {
      const relatedDocument = this.getRelatedDocumentByLinkId(linkId) as RelatedDocumentModel;

      const document = relatedDocument.documents.find((x: DocumentDataModel) => x.id === documentId && x.cabinet.id === cabinetId.toString()) as DocumentDataModel;

      return document.documentType;
    },
    sortDocumentDate(aRow: any, bRow: any, key: any, sortDesc: any, formatter: any, compareOptions: any, compareLocale: any) {
      if (key !== 'cb_docdate') {
        return null;
      }
      const documentDateDiff = new Date(aRow?.cb_docdate).getTime() - new Date(bRow?.cb_docdate).getTime();

      return documentDateDiff || aRow?.cb_docid - bRow?.cb_docid;
    },
    selectedRowClass(item: any, type: any) {
      if (!item || type !== 'row') {
        return;
      }

      if (this.relatedDocumentIsBeingViewed(item)) {
        return 'table-success';
      }
    },
    collapseShown(relatedDocumentLinkId: any) {
      this.collapseLoading = false;
      this.documentLinkId = relatedDocumentLinkId;
    },
    collapseShow(this: any) {
      this.collapseLoading = true;
    },
    scrollToDocumentBeingViewed(this: any) {
      const relatedDocumentViewModel: RelatedDocumentViewModel = this.relatedDocumentBeingViewed;

      if (relatedDocumentViewModel && relatedDocumentViewModel.documentSearchModel) {
        const documentId = relatedDocumentViewModel.documentSearchModel.documentId;
        const element = this.$el.querySelector(`#relatedDocument-${relatedDocumentViewModel.linkId}__row_${documentId}`) as HTMLElement;
        if (element) {
          this.$nextTick(() => element.scrollIntoView(false));
        }
      }
    },
    getColumns(columnIds: number[]) {
      const columns: BaseColumnsModel[] = [];
      columnIds.forEach((id) => {
        columns.push(this.relatedDocumentsModel.columns[id]);
      });
      return columns;
    },
    getDocumentTypeFromId(targetDocumentTypeId: number) {
      return this.relatedDocumentsModel.documentTypes[targetDocumentTypeId];
    }
  },
  computed: {
    ...mapGetters('documentViewStore', ['documentSearchModel', 'relatedDocumentBeingViewed', 'deletedPage']),
    ...mapGetters('relatedDocumentsStore', ['isLoading', 'relatedDocumentsModel', 'getRelatedDocumentByLinkId', 'totalDocumentsCount']),
    relatedDocumentsToDisplay(this: any): RelatedDocumentModel[] {
      const relatedDocuments = this.relatedDocumentsModel.relatedDocuments
        .filter((x: RelatedDocumentModel) => x.documentCount > 0)
        .sort((x: RelatedDocumentModel) => this.getDocumentTypeFromId(x.targetDocumentTypeId));
      if (relatedDocuments.length === 1) {
        relatedDocuments.map((x: RelatedDocumentModel) => (x.documentCount > 0 ? (x.visible = true) : false));
      }
      return relatedDocuments;
    },
    readyToScroll(this: any) {
      const flag = this.collapseLoading;
      return this.relatedDocumentBeingViewed;
    },
    isDocumentLoadingOrBeingConverted(this: any) {
      return store.getters['documentViewStore/document'].isBeingConverted || store.getters['documentViewStore/isPageLoading'];
    },
    viewOriginalButtonText(this: any): string {
      return this.isRelatedDocumentOpen ? 'Close Related' : 'View Original';
    }
  },
  watch: {
    totalDocumentsCount(this: any, value: number) {
      this.$emit('tabItemCountChanged', {
        key: 'RelatedDocuments',
        itemCount: value
      } as TabStateModel);
    },
    readyToScroll(newDocumentValue, oldDocumentValue) {
      if (this.documentLinkId === newDocumentValue.linkId && !this.collapseLoading) {
        this.scrollToDocumentBeingViewed();
      }
    },
    relatedDocumentsModel(this: any, value: number) {
      this.handleTabsLoaded();
    },
    async deletedPage(value: DocumentPageModel) {
      this.updateDocumentDataPageCount({ docId: value.documentId, change: -1 });
    }
  },
  async mounted(this: any) {
    await this.getRelatedDocuments(this.documentSearchModel);
  },
  components: {
    LoadingSpinner
  },
  beforeDestroy(this: any) {
    this.unloadRelatedDocuments();
  }
});
